import React, { useEffect, useState } from 'react'
import PageHeader from '../../PageHeader/PageHeader'
import { useDispatch, useSelector } from 'react-redux';
import { getErrorMsg, hasError } from '../../utils/utils';
import AppInput from '../../components/AppInput/AppInput';
import MultiSelect from '../../components/AppSelect/MultiSelect';
import { CheckDropdownValue, monthWeeksOptions, priorityOptions, taskFrequencyOptions, taskIntervalOptions, weekDaysOptions } from '../../constant/Options';
import SearchableSelect from '../../components/AppSelect/SearchableSelect';
import { Shield } from 'lucide-react';
import { HitApi } from '../../Api/ApiHit';
import { createTask, searchRole, searchUser, updateTask } from '../../constant/Constant';
import AppButton from '../../components/AppButton/AppButton';
import { TaskValidationSchema } from '../../validationscheema/TaskValidation ';
import { setApiErrorJson } from '../../redux/Actions/ApiAction';
import { getElevateUser, getSelectedUnit } from '../../storage/Storage';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import TextArea from '../../components/AppInput/TextArea';
import DateTimePicker from '../../components/DateAndTime/DateTimePicker';
import AppSwitch from '../../components/Switch/AppSwitch';

function AddTask({ editMode }) {
    const [roleOptions, setRoleOptions] = useState([]);
    const ApiReducer = useSelector((state) => state.ApiReducer);
    const [staffOptions, setStaffOptions] = useState([]);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const url = window.location.pathname;
    const urlId = url.split('/')[3];
    const currentFrequency = ApiReducer?.apiJson?.taskFrequency;

    useEffect(() => {
        fetchRoles()
    }, [])

    useEffect(() => {
        if (ApiReducer?.apiJson?.roleId) {
            fetchStaff();
        }
    }, [ApiReducer?.apiJson?.roleId]);

    const fetchStaff = async () => {

        console.log("ApiReducerROle",ApiReducer);
        
        try {
            const json = {
                page: 1,
                limit: 50,
                search: {
                    roleId: ApiReducer?.apiJson?.roleId,
                }
            };

            const res = await HitApi(json, searchUser);

            if (res && res?.data?.docs && Array.isArray(res?.data?.docs)) {
                const options = res?.data?.docs?.map(user => ({
                    value: user._id,
                    label: user.name
                }));
                setStaffOptions(options);
            }
        } catch (error) {
            console.error("Error fetching staff:", error);
        }
    };

    const fetchRoles = async () => {
        const roleTypeOptions = CheckDropdownValue();
        try {
            const json = {
                page: 1,
                limit: 50,
                search: {
                    roleType: roleTypeOptions.map(option => option.value)
                }
            };

            const res = await HitApi(json, searchRole);

            if (res?.statusCode === 200) {
                const options = res?.data?.docs?.map(role => ({
                    value: role._id,
                    label: role.roleName
                }));
                setRoleOptions(options);
            }
        } catch (error) {
            console.error("Error fetching roles:", error);
        }
    };

    const formatTaskIntervals = (selectedIntervals) => {
        if (!selectedIntervals || selectedIntervals.length === 0) {
            return [];
        }

        return selectedIntervals.map(interval => {
            const currentDate = new Date();
            const startTime = new Date(currentDate);
            const endTime = new Date(currentDate);

            if (typeof interval === 'string') {
                if (interval.includes('-')) {
                    const [startStr, endStr] = interval.split('-');
                    const [startHour, startMin] = startStr.split(':').map(Number);
                    const [endHour, endMin] = endStr.split(':').map(Number);

                    startTime.setHours(startHour, startMin, 0, 0);
                    endTime.setHours(endHour, endMin, 0, 0);
                }
            } else if (typeof interval === 'object' && interval.value) {
                if (interval.value.includes('-')) {
                    const [startStr, endStr] = interval.value.split('-');
                    const [startHour, startMin] = startStr.split(':').map(Number);
                    const [endHour, endMin] = endStr.split(':').map(Number);

                    startTime.setHours(startHour, startMin, 0, 0);
                    endTime.setHours(endHour, endMin, 0, 0);
                }
            }

            return {
                start: startTime.getTime(),
                end: endTime.getTime(),
                status: "pending",
                interval: typeof interval === 'object' ? interval.value : interval
            };
        });
    };

    // STANDARDIZED PAYLOAD - Same structure for all frequencies
    const formatTaskData = () => {
        const formData = ApiReducer?.apiJson;

        // Base task data structure that remains same for all frequencies
        let taskData = {
            taskName: formData?.taskName || '',
            description: formData?.description || '',
            priority: formData?.priority || 'medium',
            taskFrequency: formData?.taskFrequency || 'daily',
            startDateTime: formData?.startDateTime || null,
            endDateTime: formData?.endDateTime || null,
            taskIntervals: formatTaskIntervals(formData?.taskIntervals) || [],
            roleId: formData?.roleId || '',
            assignedTo: formData?.assignedTo || [],
            unitIds: getSelectedUnit()?._id,
            status: 'active',
            isCommon: formData?.isCommon,
            createdBy :getElevateUser()?._id,
            upDatedBy :getElevateUser()?._id,

        };

        // Conditional logic based on frequency
        if (formData?.taskFrequency === 'weekly') {
            taskData.weekDaysForMonthly = formData?.weekDaysForMonthly || [];
            taskData.monthWeeks = [1, 2, 3, 4, 5];
        } else if (formData?.taskFrequency === 'daily') {
            // For daily tasks, set both weekDaysForMonthly and monthWeeks
            taskData.weekDaysForMonthly = [1, 2, 3, 4, 5, 6, 7];
            taskData.monthWeeks = [1, 2, 3, 4, 5];
        } else if (formData?.taskFrequency === 'monthly') {
            // Only for monthly, use the selected values
            taskData.weekDaysForMonthly = formData?.weekDaysForMonthly || [];
            taskData.monthWeeks = formData?.monthWeeks || [];
        }

        if (editMode) {
            taskData._id = urlId;
        }

        return taskData;
    };

    const handleSubmit = () => {
        TaskValidationSchema(ApiReducer?.apiJson).then((error) => {
            console.log("Validation errors:", error);
            dispatch(setApiErrorJson(error));

            if (Object.keys(error).length === 0) {
                const taskData = formatTaskData();


                console.log("taskData", taskData);

                const apiCall = editMode ? updateTask : createTask;
                const successMessage = editMode
                    ? 'Task updated successfully!'
                    : 'Task created successfully!';

                HitApi(taskData, apiCall)
                    .then((res) => {
                        if (res?.statusCode === 200 || res?.statusCode === 201) {
                            toast.success(successMessage);
                            navigate('/taskmanagement');
                        } else {
                            toast.error(res?.message || `Failed to ${editMode ? 'update' : 'create'} task`);
                        }
                    })
                    .catch((error) => {
                        console.error(`${editMode ? 'Update' : 'Create'} error:`, error);
                        toast.error(`Error ${editMode ? 'updating' : 'creating'} task. Please try again.`);
                    });
            }
        });
    };

    console.log("ApiReducer", ApiReducer);
    return (
        <div className='p-5'>
            <PageHeader
                title={editMode ? 'Edit Task' : 'Add Task'}
                description={editMode ? 'Update existing task details' : 'Create and configure new task'}
            />
            <div className="bg-white p-8 border rounded-xl mb-6">
                <div className="text-lg font-medium mb-5 flex justify-between items-center">
                    <span> Basic Information</span>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    <AppInput
                        title="Task Name"
                        placeholder="Enter task name"
                        name="taskName"
                        important={true}
                        error={hasError('taskName', ApiReducer)}
                    />

                    <SearchableSelect
                        title="Priority Level"
                        name="priority"
                        options={priorityOptions}
                        important={true}
                        error={hasError('priority', ApiReducer)}
                        placeholder="Select priority level"
                    />
                </div>

                {/* Description Section */}
                <div className="mb-8">
                    <TextArea
                        title="Task Description"
                        name="description"
                        placeholder="Write detailed description about this task..."
                        important={true}
                        error={hasError('description', ApiReducer)}
                    />
                </div>

                <div className="text-lg font-medium mb-5 flex items-center">
                    <span>Schedule Task Configuration</span>
                </div>

                <div className="mb-6">
                    <SearchableSelect
                        title="Task Frequency"
                        name="taskFrequency"
                        options={taskFrequencyOptions}
                        important={true}
                        error={hasError('taskFrequency', ApiReducer)}
                        placeholder="How often should this task run?"
                    />
                    {currentFrequency && (
                        <div className="mt-2 p-3 bg-blue-50 border-l-4 border-blue-400 text-blue-700 text-sm">
                            {taskFrequencyOptions.find(opt => opt.value === currentFrequency)?.description}
                        </div>
                    )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
                    {currentFrequency === 'once' && (
                        <div className="md:col-span-3">
                            <div className='grid grid-cols-2 gap-4'>
                                <DateTimePicker
                                    title="Start Date & Time"
                                    name="startDateTime"
                                    important={true}
                                    error={hasError('startDateTime', ApiReducer)}
                                    placeholder={"Select Date and Time"}
                                />
                                <DateTimePicker
                                    title="End Date & Time"
                                    name="endDateTime"
                                    important={true}
                                    error={hasError('endDateTime', ApiReducer)}
                                    placeholder={"Select Date and Time"}
                                />
                            </div>
                        </div>
                    )}

                    {currentFrequency === 'daily' && (
                        <MultiSelect
                            title="Daily Time Intervals"
                            name="taskIntervals"
                            options={taskIntervalOptions}
                            placeholder="Select daily time intervals"
                            error={hasError('taskIntervals', ApiReducer)}
                            important={true}
                        />
                    )}

                    {currentFrequency === 'weekly' && (
                        <>
                            <MultiSelect
                                title="Days in Selected Weeks"
                                name="weekDaysForMonthly"
                                options={weekDaysOptions}
                                placeholder="Select days"
                                error={hasError('weekDaysForMonthly', ApiReducer)}
                                important={true}
                            />
                            <MultiSelect
                                title="Weekly Time Intervals"
                                name="taskIntervals"
                                options={taskIntervalOptions}
                                placeholder="Select time intervals"
                                error={hasError('taskIntervals', ApiReducer)}
                                important={true}
                            />
                        </>
                    )}

                    {currentFrequency === 'monthly' && (
                        <>
                            <MultiSelect
                                title="Weeks of Month"
                                name="monthWeeks"
                                options={monthWeeksOptions}
                                placeholder="Select weeks"
                                error={hasError('monthWeeks', ApiReducer)}
                                important={true}
                            />
                            <MultiSelect
                                title="Days in Selected Weeks"
                                name="weekDaysForMonthly"
                                options={weekDaysOptions}
                                placeholder="Select days"
                                error={hasError('weekDaysForMonthly', ApiReducer)}
                                important={true}
                            />
                            <MultiSelect
                                title="Monthly Time Intervals"
                                name="taskIntervals"
                                options={taskIntervalOptions}
                                placeholder="Select time intervals"
                                error={hasError('taskIntervals', ApiReducer)}
                                important={true}
                            />
                        </>
                    )}
                </div>

                {/* Assignment Section */}
                <div className="text-lg font-medium mb-5 flex items-center">
                    <span>Task Assignment</span>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                    <SearchableSelect
                        title="Role"
                        name="roleId"
                        options={roleOptions}
                        important={true}
                        error={hasError('roleId', ApiReducer)}
                        icon={<Shield size={18} />}
                        placeholder="Select role"
                    />

                    {ApiReducer?.apiJson?.roleId && (
                        <MultiSelect
                            title="Assign to Specific Users"
                            name="assignedTo"
                            options={staffOptions}
                            error={hasError('assignedTo', ApiReducer)}
                            placeholder="Select users"
                        />
                    )}
                    {ApiReducer?.apiJson?.assignedTo?.length >= 2 &&
                        <AppSwitch
                            title="Group Task"
                            name="isCommon"
                            specification="Toggle to enable or disable the group task"
                        />
                    }

                </div>
                <div className='flex justify-end space-x-4'>
                    <AppButton
                        buttontext={editMode ? "Update Task" : "Create Task"}
                        onClick={handleSubmit}
                    />
                </div>
            </div>
        </div>
    )
}

export default AddTask